export default "__VITE_ASSET__CSqZQ5XT__"